/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {SpeciesModal} from "./SpeciesModal";
import {SpeciesSummary} from "../../../../Common/ModelRenderers/SpeciesSummary";

export const EditSpeciesModal = (props) => {
	return <SpeciesModal
		{...props}
		title="Edit Species"
		summaryComponent={SpeciesSummary}
		hiddenFields={[
			'SpeciesRequest_observedProjectContextNodeId',
			'SpeciesRequest_observedDate',
			'SpeciesRequest__speciesListIds',
			'SpeciesRequest_requesterNotes',
			'SpeciesRequest_reviewerNotes',

 			'SpeciesRequest_requested',
			'SpeciesRequest_requestedByUserId',
			'SpeciesRequest_speciesRequestSourceId',
			'SpeciesRequest_reviewed',
			'SpeciesRequest_reviewedByUserId',
			'SpeciesRequest__speciesListIds',
		]}
		confirmationButtonMessage="Save"
	/>;
}
